import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination, EffectFade } from 'swiper/modules';

const blocks = document.querySelectorAll('.block-tab-content');

blocks.forEach((block, index) => {
	const slider = block.querySelector('.swiper');

	if (!slider) {
		return;
	}

	block.classList.add(`block-tab-content--${index}`);

	const setProgress = (swiper) => {
		const progressPercentage =
			(swiper.activeIndex + 1) / swiper.slides.length;
		block.style.setProperty('--swiper-progress', `${progressPercentage}`);
	};

	let desktopAutoHeight = false;

	if (block.classList.contains('block-tab-content--expand-images')) {
		desktopAutoHeight = true;
	}

	const settings = {
		loop: false,
		grabCursor: true,
		spaceBetween: 0,
		slidesPerView: 1,
		autoHeight: true,
		modules: [A11y, Navigation, Pagination, EffectFade],
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: `.block-tab-content--${index} .swiper-button-prev`,
			nextEl: `.block-tab-content--${index} .swiper-button-next`,
		},
		pagination: {
			el: `.block-tab-content--${index} .swiper-pagination`,
			clickable: true,
			renderBullet(i, className) {
				const num = (i + 1).toString().padStart(2, '0');
				return `<span class="${className}">${num}</span>`;
			},
		},
		on: {
			init(swiper) {
				setProgress(swiper);
			},
			slideChange(swiper) {
				setProgress(swiper);
			},
		},
		breakpoints: {
			768: {
				autoHeight: desktopAutoHeight,
			},
		},
	};

	new Swiper(slider, settings);
});

const interactionEvents = [
	'pointerdown',
	'pointermove',
	'keydown',
	'touchstart',
	'wheel',
	'scroll',
];

const loadFullImages = () => {
	interactionEvents.forEach((event) =>
		window.removeEventListener(event, loadFullImages)
	);

	const templates = document.querySelectorAll(
		'.block-tab-content--expand-images .block-tab-content-tab__full-image-template'
	);

	templates.forEach((template) => {
		const fullImage = template.content.querySelector('img');
		const wrapper = template.parentElement.querySelector(
			'.block-tab-content-tab__image-wrapper'
		);

		if (!fullImage || !wrapper) {
			return;
		}

		const image = fullImage.cloneNode();
		const reveal = () => image.classList.add('is-loaded');

		image.classList.add('block-tab-content-tab__full-image');
		image.setAttribute('aria-hidden', 'true');
		image.alt = '';
		image.addEventListener('load', reveal, { once: true });

		// Insert directly after the original so any video play button stays on top.
		const originalImage = wrapper.querySelector('img');

		if (originalImage) {
			originalImage.after(image);
		} else {
			wrapper.prepend(image);
		}

		if (image.complete && image.naturalWidth) {
			reveal();
		}

		template.remove();
	});
};

if (document.querySelector('.block-tab-content-tab__full-image-template')) {
	interactionEvents.forEach((event) =>
		window.addEventListener(event, loadFullImages, { passive: true })
	);
}
